import {
  UPDATE_AUTHENTICATING,
  UPDATE_AUTH_STATUS,
  SET_AUTH_USER,
  SET_AUTH_GROUPS,
  SWITCH_PLAYER_MODE,
  UPDATE_USER_GENRES,
  UPDATE_USER_MOODS,
  UPDATE_USER_KEYWORDS,
  UPDATE_USER_STYLES,
  CLEAR_USER_FILTERS,
  UPDATE_USER_FILTERS,
  SET_HAS_FILTERS,
  SET_FILTER_COUNT,
  UPDATE_USER_VOCAL_TYPE,
  UPDATE_USER_BPM,
  UPDATE_USER_DURATION,
  UPDATE_CURRENT_ROUTE,
  CLEAR_DEFAULT_PLAYLIST,
  FETCH_DEFAULT_PLAYLIST,
  FETCH_SAVED_PLAYLISTS,
  LOAD_LOCAL_PLAYLIST,
  ADD_TO_SHOPPING_CART,
  REMOVE_FROM_SHOPPING_CART,
  UPDATE_LOCAL_PLAYLIST,
  UPDATE_PLAYLIST_COUNTS,
  UPDATE_FILTER_DRAWER_STATUS,
  UPDATE_SAVED_PLAYLIST_COUNT,
  UPDATE_USER_THEME,
  UPDATE_FORGOT_PASSWORD_EMAIL,
  UPDATE_PLAYLIST_VISIBLE,
} from "./types";

import axios from "axios";
import apiconfig from "../../../config/api-config.js";
import { Auth } from "aws-amplify";
import FlikTraxStore from "../FlikTraxStore";
import { apiIsLoading } from "./apiActions";

export const updatePlaylistVisible = (visible) => (dispatch) => {
  dispatch({
    type: UPDATE_PLAYLIST_VISIBLE,
    payload: visible,
  });
};

export const updateForgotPasswordEmail = (email) => (dispatch) => {
  dispatch({
    type: UPDATE_FORGOT_PASSWORD_EMAIL,
    payload: email,
  });
};

export const addToShoppingCart = (track) => (dispatch) => {
  var currentTrackIds = [];
  var currentSc = FlikTraxStore.getState().user.userShoppingCart;
  for (var i = 0; i < currentSc.length; i++) {
    currentTrackIds.push(currentSc[i].id);
  }

  if (currentTrackIds.includes(track)) {
    return;
  }

  axios({
    baseURL: "https://api.fliktrax.com/track/" + track,
    method: "get",
    auth: {
      username: apiconfig.api.APIUSERNAME,
      password: apiconfig.api.APIPASSWORD,
    },
    headers: {
      "Content-Type": "application/hal+json",
    },
    //timeout: 2000,
  }).then((response) => {
    dispatch({
      type: ADD_TO_SHOPPING_CART,
      payload: response.data,
    });
  });
};

export const updateUserTheme = (theme) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_THEME,
    payload: theme,
  });
};

export const removeShoppingCartItem = (track) => (dispatch) => {
  dispatch({
    type: REMOVE_FROM_SHOPPING_CART,
    payload: track,
  });
};

export const updateAuthenticating = (status) => (dispatch) => {
  dispatch({
    type: UPDATE_AUTHENTICATING,
    payload: status,
  });
};

export const updateAuthStatus = (status) => (dispatch) => {
  dispatch({
    type: UPDATE_AUTH_STATUS,
    payload: status,
  });
};

export const setAuthUser = (user) => (dispatch) => {
  dispatch({
    type: SET_AUTH_USER,
    payload: user,
  });
};

export const setAuthGroups = (groups) => (dispatch) => {
  dispatch({
    type: SET_AUTH_GROUPS,
    payload: groups,
  });
};

export const updateSavedPlaylistCount = (count) => (dispatch) => {
  dispatch({
    type: UPDATE_SAVED_PLAYLIST_COUNT,
    payload: count,
  });
};

export const updatePlaylistCounts = () => (dispatch) => {
  var currentUser = FlikTraxStore.getState().user;
  var userID = currentUser.user.username;

  axios({
    baseURL: "https://api.fliktrax.com/userplaylist",
    method: "post",
    auth: {
      username: apiconfig.api.APIUSERNAME,
      password: apiconfig.api.APIPASSWORD,
    },
    data: {
      cmd: "plcounts",
      userid: userID,
      partner: "cjz-media",
    },
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: UPDATE_PLAYLIST_COUNTS,
      payload: response.data,
    });
  });
};

export const updateUserFilters = (value) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_FILTERS,
    payload: value,
  });
};

export const updateUserVocalType = (vocaltype) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_VOCAL_TYPE,
    payload: vocaltype,
  });
};

export const updateUserGenres = (value) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_GENRES,
    payload: value,
  });
};

export const updateUserMoods = (value) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_MOODS,
    payload: value,
  });
};

export const updateUserKeywords = (value) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_KEYWORDS,
    payload: value,
  });
};

export const updateUserStyles = (value) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_STYLES,
    payload: value,
  });
};

export const initializeFilters = () => (dispatch) => {
  dispatch({
    type: UPDATE_USER_STYLES,
    payload: [],
  });

  dispatch({
    type: UPDATE_USER_KEYWORDS,
    payload: [],
  });

  dispatch({
    type: UPDATE_USER_MOODS,
    payload: [],
  });

  dispatch({
    type: UPDATE_USER_GENRES,
    payload: [],
  });

  dispatch({
    type: UPDATE_USER_VOCAL_TYPE,
    payload: [],
  });
};

export const setFilterCount = () => (dispatch) => {
  let currentVocalCount = 0;
  if (
    FlikTraxStore.getState().user &&
    FlikTraxStore.getState().user.userVocalTypes &&
    FlikTraxStore.getState().user.userVocalTypes.hasOwnProperty(0)
  ) {
    currentVocalCount = 1;
  }
  let currentGenresCount =
    FlikTraxStore.getState().user &&
    parseInt(FlikTraxStore.getState().user.userGenres.length);
  let currentMoodsCount =
    FlikTraxStore.getState().user &&
    parseInt(FlikTraxStore.getState().user.userMoods.length);
  let currentKeywordsCount =
    FlikTraxStore.getState().user &&
    parseInt(FlikTraxStore.getState().user.userKeywords.length);
  let currentBpmCount = 0;
  if (
    FlikTraxStore.getState().user &&
    FlikTraxStore.getState().user.userBpm &&
    FlikTraxStore.getState().user.userBpm !== undefined &&
    FlikTraxStore.getState().user.userBpm.length > 0
  ) {
    currentBpmCount = 1;
  }

  let filterCount = [
    currentVocalCount,
    currentGenresCount,
    currentMoodsCount,
    currentKeywordsCount,
    currentBpmCount,
  ].reduce((a, b) => a + b, 0);

  dispatch({
    type: SET_FILTER_COUNT,
    payload: filterCount,
  });
};

export const clearUserFilters = () => (dispatch) => {
  dispatch({
    type: CLEAR_USER_FILTERS,
  });
};

export const updateUserBpm = (bpm) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_BPM,
    payload: bpm,
  });
};

export const updateUserDuration = (duration) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_DURATION,
    payload: duration,
  });
};

export const updateCurrentRoute = (route) => (dispatch) => {
  dispatch({
    type: UPDATE_CURRENT_ROUTE,
    currentRoute: route,
  });
};

export const switchPlayerMode = (mode) => (dispatch) => {
  dispatch({
    type: SWITCH_PLAYER_MODE,
    payload: mode,
  });
};

export const addToPlaylist = (track) => (dispatch) => {
  var currentUser = FlikTraxStore.getState().user;
  var userID = currentUser.user.username;

  if (userID !== null) {
    axios({
      baseURL: "https://api.fliktrax.com/userplaylist",
      method: "post",
      auth: {
        username: apiconfig.api.APIUSERNAME,
        password: apiconfig.api.APIPASSWORD,
      },
      data: {
        cmd: "add",
        userid: userID,
        trackid: track,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      //console.log(response.data.playlist)
    });
  }
};

export const loadLocalPlaylist = () => (dispatch) => {
  var currentUser = FlikTraxStore.getState().user;
  var userID = currentUser && currentUser.user.username;

  axios({
    baseURL: "https://api.fliktrax.com/userplaylist",
    method: "post",
    auth: {
      username: apiconfig.api.APIUSERNAME,
      password: apiconfig.api.APIPASSWORD,
    },
    data: {
      userid: userID,
    },
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    var oPlaylist = response.data.playlist;
    dispatch({
      type: LOAD_LOCAL_PLAYLIST,
      payload: oPlaylist,
    });
  });
};

export const removeFromPlaylist = (track) => (dispatch) => {
  var currentUser = FlikTraxStore.getState().user;
  var userID = currentUser.user.username;

  if (userID !== null) {
    axios({
      baseURL: "https://api.fliktrax.com/userplaylist",
      method: "post",
      auth: {
        username: apiconfig.api.APIUSERNAME,
        password: apiconfig.api.APIPASSWORD,
      },
      data: {
        cmd: "delete",
        userid: userID,
        trackid: track,
      },
      headers: {
        "Content-Type": "application/json",
      },
    });
    // .then(response => {
    //     console.log(response.data)
    // })
  }
};

export const clearDefaultPlaylist = () => (dispatch) => {
  var currentUser = FlikTraxStore.getState().user;
  var userID = currentUser.user.username;

  if (userID !== null) {
    axios({
      baseURL: "https://api.fliktrax.com/userplaylist",
      method: "post",
      auth: {
        username: apiconfig.api.APIUSERNAME,
        password: apiconfig.api.APIPASSWORD,
      },
      data: {
        cmd: "clear",
        userid: userID,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      dispatch({
        type: CLEAR_DEFAULT_PLAYLIST,
      });
    });
  }
};

export const fetchSavedPlaylists = () => (dispatch) => {
  FlikTraxStore.dispatch(apiIsLoading(true));

  const userStatus = async () => {
    try {
      const userInfo = await Auth.currentUserInfo();
      return userInfo.username;
    } catch (e) {
      console.log(e.message);
    }
  };

  userStatus().then((userID) => {
    axios({
      baseURL: "https://api.fliktrax.com/userplaylist",
      method: "post",
      auth: {
        username: apiconfig.api.APIUSERNAME,
        password: apiconfig.api.APIPASSWORD,
      },
      data: {
        cmd: "fetch",
        userid: userID,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      FlikTraxStore.dispatch(apiIsLoading(false));
      dispatch({
        type: FETCH_SAVED_PLAYLISTS,
        payload: response.data,
      });
    });
  });
};

export const fetchDefaultPlaylist = () => (dispatch) => {
  FlikTraxStore.dispatch(apiIsLoading(true));

  const userStatus = async () => {
    try {
      const userInfo = await Auth.currentUserInfo();
      return userInfo.username;
    } catch (e) {
      console.log(e.message);
    }
  };

  userStatus().then((userID) => {
    axios({
      baseURL: "https://api.fliktrax.com/userplaylist",
      method: "post",
      auth: {
        username: apiconfig.api.APIUSERNAME,
        password: apiconfig.api.APIPASSWORD,
      },
      data: {
        cmd: "fetch-default",
        userid: userID,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      FlikTraxStore.dispatch(apiIsLoading(false));
      dispatch({
        type: FETCH_DEFAULT_PLAYLIST,
        payload: response.data[0] && Object.values(response.data[0].playlist),
      });
    });
  });
};

export const deleteSavedPlaylist = (playlistId) => (dispatch) => {
  var currentUser = FlikTraxStore.getState().user;
  var userID = currentUser.user.username;

  if (userID !== null) {
    axios({
      baseURL: "https://api.fliktrax.com/userplaylist",
      method: "post",
      auth: {
        username: apiconfig.api.APIUSERNAME,
        password: apiconfig.api.APIPASSWORD,
      },
      data: {
        cmd: "remove",
        userid: userID,
        trackid: playlistId,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      console.log(response.data);
    });
  }
};

export const saveDefaultPlaylist =
  (playlisttitle, removeDefault = false) =>
  (dispatch) => {
    var currentUser = FlikTraxStore.getState().user;
    var userID = currentUser.user.username;

    if (userID !== null) {
      axios({
        baseURL: "https://api.fliktrax.com/userplaylist",
        method: "post",
        auth: {
          username: apiconfig.api.APIUSERNAME,
          password: apiconfig.api.APIPASSWORD,
        },
        data: {
          cmd: "save",
          userid: userID,
          track_title: playlisttitle,
          clear_default: removeDefault ? true : false,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        dispatch({
          type: UPDATE_SAVED_PLAYLIST_COUNT,
          payload: response.data.playlistCount,
        });
      });
    }
  };

export const downloadPlaylist = (playlistId) => (dispatch) => {
  var currentUser = FlikTraxStore.getState().user;
  var userID = currentUser.user.username;
  var userEmail = currentUser.user.attributes.email;
  var isadmin = FlikTraxStore.getState().user.isAdmin;

  axios({
    baseURL: "https://api.fliktrax.com/userplaylist",
    method: "post",
    auth: {
      username: apiconfig.api.APIUSERNAME,
      password: apiconfig.api.APIPASSWORD,
    },
    data: {
      cmd: "download",
      userid: userID,
      isAdmin: isadmin,
      useremail: userEmail,
      playlistid: playlistId,
    },
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    console.log(response.data);
  });
};

export const updatePlaylistFromLocal = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_LOCAL_PLAYLIST,
    payload: data,
  });
};

export const loadSavedPlaylistCount = () => (dispatch) => {
  var currentUser = FlikTraxStore.getState().user;
  var userID = currentUser.user.username;

  if (userID !== null) {
    axios({
      baseURL: "https://api.fliktrax.com/userplaylist",
      method: "post",
      auth: {
        username: apiconfig.api.APIUSERNAME,
        password: apiconfig.api.APIPASSWORD,
      },
      data: {
        cmd: "countsp",
        userid: userID,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_SAVED_PLAYLIST_COUNT,
        payload: response.data.playlist_count,
      });
    });
  }
};

export const updateFilterDrawerStatus = (status) => (dispatch) => {
  dispatch({
    type: UPDATE_FILTER_DRAWER_STATUS,
    payload: status,
  });
};

export const smsNotify = (subject, message) => (dispatch) => {
  axios({
    baseURL: "https://api.fliktrax.com/services",
    method: "post",
    auth: {
      username: apiconfig.api.APIUSERNAME,
      password: apiconfig.api.APIPASSWORD,
    },
    data: {
      service: "notify-service",
      subject: subject,
      message: encodeURIComponent(message),
    },
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    //console.log(response.data)
  });
};
